"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1143],{

/***/ 28901:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _propTypes = _interopRequireDefault(__webpack_require__(8131));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Influencer = {};
var influencerProps = {
  name: _propTypes["default"].string.isRequired,
  image: _propTypes["default"].object.isRequired,
  url: _propTypes["default"].string.isRequired,
  username: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string
};
Influencer.shape = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.length > 0 ? _propTypes["default"].shape(props.reduce(function (current, prop) {
    return _objectSpread(_objectSpread({}, current), {}, (0, _defineProperty2["default"])({}, prop, influencerProps[prop]));
  }, {})) : _propTypes["default"].shape(influencerProps);
};
var _default = Influencer;
exports["default"] = _default;

/***/ }),

/***/ 74320:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireDefault = __webpack_require__(7125);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(__webpack_require__(20389));
var _propTypes = _interopRequireDefault(__webpack_require__(8131));
var _Influencer = _interopRequireDefault(__webpack_require__(28901));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Inspiration = {};
var inspirationProps = {
  title: _propTypes["default"].string.isRequired,
  mainImage: _propTypes["default"].object.isRequired,
  thumbnails: _propTypes["default"].arrayOf(_propTypes["default"].object),
  influencerData: _Influencer["default"].shape("name", "url", "username", "description", "image"),
  cardLink: _propTypes["default"].string.isRequired
};
Inspiration.shape = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.length > 0 ? _propTypes["default"].shape(props.reduce(function (current, prop) {
    return _objectSpread(_objectSpread({}, current), {}, (0, _defineProperty2["default"])({}, prop, inspirationProps[prop]));
  }, {})) : _propTypes["default"].shape(inspirationProps);
};
var _default = Inspiration;
exports["default"] = _default;

/***/ }),

/***/ 28530:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Inspiration = _interopRequireDefault(__webpack_require__(74320));
var _RouteContext = __webpack_require__(73157);
var _getRouteFromUrl = _interopRequireDefault(__webpack_require__(61328));
var __jsx = _react["default"].createElement;
var ArrowRightIcon = function ArrowRightIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.128 12.238l-2.976-2.975.848-.849 4.425 4.424L18 17.263l-.848-.849 2.976-2.976H1.576v-1.2h18.552z"
  }));
};
ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var InspirationCard = function InspirationCard(props) {
  var _props$inspiration = props.inspiration,
    mainImage = _props$inspiration.mainImage,
    thumbnails = _props$inspiration.thumbnails,
    title = _props$inspiration.title,
    cardLink = _props$inspiration.cardLink,
    influencerData = _props$inspiration.influencerData;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _ref = influencerData ? influencerData : "",
    image = _ref.image,
    username = _ref.username;
  var translations = {
    by: (0, _langLibrary["default"])("by")
  };
  var routeFromUrl = (0, _getRouteFromUrl["default"])(cardLink);
  var route = routeFromUrl ? routeFromUrl : "category-page";
  var url = cardLink.lastIndexOf("/", 0) === 0 ? cardLink.slice(1) : cardLink;
  return __jsx(_Box["default"], {
    sx: {
      width: "100%",
      pb: "s7",
      position: "relative"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Image["default"], {
    sx: {
      width: "100%",
      height: ["250px", null, null, "375px"],
      aspectRatio: 1.333
    },
    image: mainImage,
    sizes: "(max-width: 1335px) and (min-width: 705px) 420px, 768px",
    mode: "cover"
  }), username !== undefined && __jsx(_Box["default"], {
    sx: {
      display: "inline-block",
      width: "60px",
      height: "60px",
      position: "absolute",
      top: "15px",
      left: "15px",
      zIndex: 1
    }
  }, __jsx(_Image["default"], {
    image: image,
    sx: {
      width: "54px",
      height: "54px",
      borderRadius: "50px",
      border: "3px",
      borderStyle: "solid",
      borderColor: "white",
      overflow: "hidden"
    },
    sizes: "500px"
  }))), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      mt: "s7"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      maxWidth: username !== undefined ? "70%" : "100%",
      color: "main"
    }
  }, __jsx(_Box["default"], {
    as: "h3",
    sx: {
      font: "heading3",
      pr: "s5"
    }
  }, title), __jsx(ArrowRightIcon, null)), username !== undefined && __jsx(_Box["default"], {
    as: "p",
    sx: {
      color: "main",
      font: "s",
      textAlign: "left"
    }
  }, translations.by + " ", __jsx(_Box["default"], {
    as: "span",
    sx: {
      font: "s_italic"
    }
  }, "@", username))), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      alignItems: "center",
      mt: "s7"
    }
  }, thumbnails && thumbnails.map(function (thumbnail, index) {
    return __jsx(_Image["default"], {
      image: thumbnail,
      key: index,
      sx: {
        width: ["67px", null, null, "80px"],
        height: ["67px", null, null, "80px"]
      },
      sizes: "100px"
    });
  })), __jsx(Link, {
    route: route,
    params: {
      url: url
    }
  }, __jsx(_LinkRaw["default"], {
    title: title,
    sx: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: "0",
      left: "0",
      zIndex: "1"
    }
  })));
};
var _default = InspirationCard;
exports.Z = _default;

/***/ }),

/***/ 26254:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _LinkRaw = _interopRequireDefault(__webpack_require__(88244));
var _QuantityPicker = __webpack_require__(34345);
var _Image = _interopRequireDefault(__webpack_require__(90451));
var _RouteContext = __webpack_require__(73157);
var _useCartModifier2 = _interopRequireDefault(__webpack_require__(82106));
var _useOptionPicker2 = _interopRequireDefault(__webpack_require__(55546));
var _usePriceWithCurrency = _interopRequireDefault(__webpack_require__(81890));
var _useCategoryTree2 = __webpack_require__(28452);
var _useAnalytics4AndCommerceTags = _interopRequireDefault(__webpack_require__(79892));
var _getLowProductAvailability = _interopRequireDefault(__webpack_require__(63712));
var _Product = _interopRequireDefault(__webpack_require__(71438));
var __jsx = _react["default"].createElement;
var defaultProps = {
  showOptionsSelector: false,
  addToCartDisabled: false
};
var MinifiedProductPanel = function MinifiedProductPanel(props) {
  var _useOptionPicker = (0, _useOptionPicker2["default"])(props.product),
    product = _useOptionPicker.product,
    options = _useOptionPicker.options,
    selectedValues = _useOptionPicker.selectedValues;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var optionsSelector = props.optionsSelector,
    qtyPicker = props.qtyPicker,
    toCartButton = props.toCartButton,
    promoLabel = props.promoLabel,
    _props$showOptionsSel = props.showOptionsSelector,
    showOptionsSelector = _props$showOptionsSel === void 0 ? defaultProps.showOptionsSelector : _props$showOptionsSel,
    _props$addToCartDisab = props.addToCartDisabled,
    addToCartDisabled = _props$addToCartDisab === void 0 ? defaultProps.addToCartDisabled : _props$addToCartDisab;
  var outOfStock = (0, _getLowProductAvailability["default"])(product.availability.level);
  var price = product.price,
    image = product.image,
    name = product.name,
    sku = product.sku,
    selectedOptions = product.selectedOptions;
  var translations = {
    viewDetails: (0, _langLibrary["default"])("View details"),
    addToCart: (0, _langLibrary["default"])("Add to cart"),
    outOfStock: (0, _langLibrary["default"])("Out of stock"),
    brexit: (0, _langLibrary["default"])("Brexit"),
    productCode: (0, _langLibrary["default"])("product code")
  };
  var optionsSelector$ = /*#__PURE__*/_react["default"].cloneElement(optionsSelector, {
    options: options,
    selectedValues: selectedValues,
    minifiedVersion: true
  });
  var quantityPicker = (0, _QuantityPicker.useQuantityPicker)({
    maxValue: __webpack_require__.g.__appConfig__.quantityPickerMaxValue
  });
  var _useCartModifier = (0, _useCartModifier2["default"])({
      product: product,
      onSuccess: function onSuccess() {
        quantityPicker.reset();
      }
    }),
    loading = _useCartModifier.loading,
    add = _useCartModifier.add;
  var addToCartButton = /*#__PURE__*/_react["default"].cloneElement(toCartButton, {
    isLoading: loading,
    onClick: function onClick() {
      if (!loading && !outOfStock) {
        add(quantityPicker.amount);
      }
    },
    disabled: outOfStock
  }, translations.addToCart);
  var quantityPickerComponent = /*#__PURE__*/_react["default"].cloneElement(qtyPicker, {
    controller: quantityPicker
  });
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productClicked = _useAnalyticsAndComme.productClicked;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  var brexit = __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "xs"
    }
  }, translations.brexit);
  return __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "row",
      mb: "s7"
    }
  }, __jsx(_Box["default"], {
    sx: {
      width: [160, null, null, 240],
      position: "relative",
      zIndex: "1"
    }
  }, __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      return productClicked(product, getCategoryNameForGivenCategoryId(product.category.id));
    }
  }, __jsx(_Image["default"], {
    overlay: true,
    sx: {
      aspectRatio: 1,
      objectFit: "contain",
      width: "100%"
    },
    image: image,
    sizes: "(max-width: 1410px) and (min-width: 10px) 210px, 420px",
    cloudflareEnabled: __webpack_require__.g.__appConfig__.smallImageCloudflareEnabled,
    quality: __webpack_require__.g.__appConfig__.smallImageQuality
  }))), promoLabel && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      zIndex: "2",
      top: "8px",
      right: "9px"
    }
  }, promoLabel)), __jsx(_Box["default"], {
    sx: {
      width: ["calc(100% - 160px)", null, null, "calc(100% - 320px)"],
      display: "flex",
      flexDirection: "column",
      px: 24
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: "neutral700",
      font: "xs_underline",
      mb: "s1",
      textDecoration: "none"
    }
  }, translations.productCode, " ", sku), outOfStock && __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "body2",
      color: "neutral900"
    }
  }, translations.outOfStock), __jsx(_Box["default"], {
    sx: {
      color: outOfStock ? "neutral700" : "main",
      font: "body2",
      mb: "s3"
    }
  }, name), __jsx(_Box["default"], {
    sx: {
      color: "neutral700",
      textTransform: "capitalize",
      font: "xs",
      mb: "s3"
    }
  }, selectedOptions && Object.keys(selectedOptions)[0], " ", selectedOptions && Object.values(selectedOptions)[0]), price.special ? __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, __jsx(_Box["default"], {
    sx: {
      font: "base_sans_regular_discount",
      color: outOfStock ? "neutral700" : "main"
    }
  }, priceWithCurrency(price.regular)), __jsx(_Box["default"], {
    sx: {
      font: "base_sans_bold",
      color: outOfStock ? "neutral700" : "negative"
    }
  }, priceWithCurrency(price.special))) : __jsx(_Box["default"], {
    sx: {
      color: outOfStock ? "neutral700" : "main",
      font: "base_sans_bold"
    }
  }, priceWithCurrency(price.regular)), __jsx(_Box["default"], {
    sx: {
      color: "neutral700",
      font: "xs_underline"
    }
  }, __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: name,
    onClick: function onClick() {
      return productClicked(product, getCategoryNameForGivenCategoryId(product.category.id));
    }
  }, translations.viewDetails)))), __jsx(_Box["default"], {
    sx: {
      width: 158,
      display: showOptionsSelector ? "none" : ["none", null, null, "flex"],
      flexDirection: ["row", null, null, "column"]
    }
  }, addToCartDisabled ? brexit : __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], null, quantityPickerComponent), __jsx(_Box["default"], {
    sx: {
      mt: "s6",
      width: "100%",
      minWidth: "100%"
    }
  }, addToCartButton)))), showOptionsSelector && __jsx(_Box["default"], null, optionsSelector$), __jsx(_Box["default"], {
    sx: {
      display: showOptionsSelector ? "flex" : ["flex", null, null, "none"],
      flexDirection: "row",
      justifyContent: "space-between"
    }
  }, addToCartDisabled ? brexit : __jsx(_react["default"].Fragment, null, __jsx(_Box["default"], {
    sx: {
      width: ["160px", null, null, "233px"]
    }
  }, quantityPickerComponent), __jsx(_Box["default"], null, addToCartButton))));
};
var _default = MinifiedProductPanel;
exports.Z = _default;

/***/ }),

/***/ 66836:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Grid = _interopRequireDefault(__webpack_require__(98290));
var _Container = _interopRequireDefault(__webpack_require__(58709));
var __jsx = _react["default"].createElement;
var Grid2Cards = function Grid2Cards(props) {
  var children = props.children;
  return __jsx(_Container["default"], null, __jsx(_Grid["default"], {
    cols: [1, 1, 2, 2, 2]
  }, children));
};
var _default = Grid2Cards;
exports.Z = _default;

/***/ }),

/***/ 15845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_InspirationCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28530);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InspirationCard = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_InspirationCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (InspirationCard);


/***/ }),

/***/ 35660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_MinifiedProductPanel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26254);
/* harmony import */ var _OptionsSelector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50014);
/* harmony import */ var _deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51586);
/* harmony import */ var _quantityPickers_QuantityPicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72565);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MinifiedProductPanel = function(props) {
    var propsExt = _objectSpread({}, props, {
        optionsSelector: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OptionsSelector__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
        toCartButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_4__["default"], {
            sx: {
                minWidth: [
                    "160px",
                    null,
                    null,
                    "100%"
                ]
            }
        }),
        qtyPicker: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_quantityPickers_QuantityPicker__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_MinifiedProductPanel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ __webpack_exports__["Z"] = (MinifiedProductPanel);


/***/ }),

/***/ 90485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_sections_Grid2Cards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66836);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Grid2Cards = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_sections_Grid2Cards__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Grid2Cards);


/***/ }),

/***/ 44553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88778);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SectionWithConfigurableHeader = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_sections_SectionWithConfigurableHeader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionWithConfigurableHeader);


/***/ })

}]);